<template lang="pug">
ul.pagination__list
  li.pagination__item.pagination__item_back
    a.pagination__link.pagination__link_back(v-if="value > 1" href="" @click.prevent="setPage(value - 1)") Back
    span.pagination__link.pagination__link_back(v-else) Back
  li.pagination__item(v-for="i in pages" :class="{ pagination__item_active: i == value }")
    a.pagination__link(href="" @click.prevent="setPage(i)") {{ i }}
  li.pagination__item.pagination__item_next
    a.pagination__link.pagination__link_next(v-if="value < pages" href="" @click.prevent="setPage(value + 1)") Next
    span.pagination__link.pagination__link_next(v-else) Next
</template>

<script>
import Cookies from 'js-cookie'

export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    pages: {
      type: Number,
      required: true,
    },
    cookie: {
      type: String,
      required: true
    }
  },

  methods: {
    setPage(page) {
      this.$emit('input', page)
      Cookies.set(this.cookie, page)
    },
  },
}
</script>

<style lang="scss">
.pagination__list {
  .pagination__item {
    a.pagination__link:hover {
      color: red;
    }
  }
}
</style>
